import { Answer, Content, Score, TestableWord } from "../types";

export function getCurrentScore(score: Score): number {
  return Object.values(score.words).filter(s => s).length;
}

export function getScoreTotal(score: Score): number {
  return Object.values(score.words).length;
}

export function getTestableWordsInfo(content: Content): TestableWord[] {
  return content.words.filter(
    word => typeof word !== "string"
  ) as TestableWord[];
}

export function getTestableWords(content: Content): Array<string> {
  return getTestableWordsInfo(content).map((item: any) => item.word);
}

export function updateWordAnswer(
  currentAnswer: Answer,
  attempting: string,
  userInput: string
): Answer {
  return {
    ...currentAnswer,
    words: { ...currentAnswer.words, [attempting]: userInput }
  };
}
